import { GhostAI } from './GhostAI';
import Ghost, { GhostState } from '../Ghost';
import { Moves } from '../grid/grid';
import { tileSize } from '~/src/consts/sizes';

export default class HouseAI implements GhostAI {
	private readonly ghost: Ghost;
	public speed = 0;
	public targetPosition: Required<Phaser.Types.Math.Vector2Like> = {
		x: 448,
		y: 432
	};

	constructor(ghost: Ghost) {
		this.ghost = ghost;
		this.speed = 4 * tileSize;
		this.ghost.ghostState = GhostState.House;
	}

	chooseTarget() {
		const { x, y } = this.ghost;
		const { x: tx, y: ty } = this.targetPosition;

		if (x === tx && y === ty) {
			this.ghost.hasRespawned();
			return;
		}

		if (Math.round(x) === tx) {
			this.ghost.setPosition(tx, this.ghost.y);
			this.ghost.changeDirection(Moves.Up);
		} else if (x < tx) {
			this.ghost.changeDirection(Moves.Right);
		} else {
			this.ghost.changeDirection(Moves.Left);
		}
	}
}
